import { GroupConfigurations } from './GroupConfigurations.js';

class GroupSubstitutions extends GroupConfigurations {

  remove({withoutConfirm = false} = {withoutConfirm: false}) {
    if (this.isDisabled) {
      return;
    }

    return this.rootStore.cartStore.removeGroup({item: this, contentText: this.removeQuestion, withoutConfirm});
  }

  constructor({item, rootStore, shouldExpandGroup = false, remove}) {
    super({item, rootStore, shouldExpandGroup, remove});

    this.remove = this.remove.bind(this);
    //temporary solution until label would be created
    this.removeQuestion = this.rootStore.labelsStore.allProducts;
  }

}

export { GroupSubstitutions };